// extracted by mini-css-extract-plugin
export default {"wrapper":"FromTo_wrapper__Vd1VS","from":"FromTo_from__D4Iet","to":"FromTo_to__LudjW","content":"FromTo_content__TTa4A"};